import { createApi } from '../../../shared/redux/createApi';

export const monthlyDepositsApi = createApi({
  reducerPath: 'monthlyDepositsApi',
  tagTypes: ['MonthlyDeposits'],
  endpoints: (builder) => ({
    getMonthlyDeposits: builder.query({
      query: ({ status = 'NEW', pageNumber = 1, pageSize = 10 }) => {
        const params = new URLSearchParams();
        params.append('page_number', pageNumber);
        params.append('page_size', pageSize);
        params.append('status', status);
        params.append('is_reached', 'true');

        return {
          url: `/admin/user-monthly-deposit?${params.toString()}`,
          method: 'GET',
        };
      },
      providesTags: ['MonthlyDeposits'],
    }),
    updateMonthlyDepositStatus: builder.mutation({
      query: ({ sk, status }) => ({
        url: `/admin/user-monthly-deposit-update`,
        method: 'post',
        body: { sk, status },
      }),
      invalidatesTags: ['MonthlyDeposits'],
    }),
  }),
});

export const {
  useGetMonthlyDepositsQuery,
  useUpdateMonthlyDepositStatusMutation,
} = monthlyDepositsApi;
